import script from "./SearchPartnerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPartnerModal.vue?vue&type=script&setup=true&lang=js"

import "./SearchPartnerModal.vue?vue&type=style&index=0&id=65240c26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65240c26"]])

export default __exports__